import styled from 'styled-components';
import { media } from '../../../../../../../theme/shared/breakpoints';
import { Link } from '../../../../../../components/Link/Link';
export const CounterWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  height: auto;
`;
export const CounterSeparator = styled.div `
  height: 24px;
  padding: 2px 0;
  opacity: 0.7;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
export const CounterPartWrapper = styled.div `
  height: 37px;
  width: 44px;
  margin: 0 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;
export const CounterPartComponent = styled.div `
  display: flex;
  justify-content: space-between;
  height: auto;
`;
export const CounterPartItem = styled.div `
  height: 24px;
  width: 21px;
  padding: 2px 0;
  color: white;
  background-color: black;
  border-radius: 4px;
  font-weight: 600;

  display: flex;
  align-items: center;
  justify-content: center;

  &:first-child {
    margin-right: 2px;
  }
`;
export const CounterPartLabel = styled.div `
  font-size: 10px;
  line-height: 10px;
  font-weight: 700;
  opacity: 0.7;
  text-transform: capitalize;
`;
export const TopbarContent = styled.div `
  width: 100%;
  text-align: center;

  ${media.small} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
  }
`;
export const StyledLink = styled(Link) `
  display: inline-block;
  color: ${({ theme }) => theme.colorsV2.font.textLink};
  font-size: ${({ theme }) => theme.fontSizes.sizeSm3};
  font-weight: 600;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
export const TopbarSeparator = styled.span `
  display: inline-block;
  margin: 0 4px;
`;
//# sourceMappingURL=Counter.styled.js.map